import React from 'react'
import { useEffect, useState, useRef, useImperativeHandle, forwardRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import EntryBase from "../components/EntryBase";
import EntryRemarks from "../components/EntryRemarks";
import EntryGrid from "../components/EntryGrid";
import EntryImages from "../components/EntryImages";
import EntryFiles from "../components/EntryFiles";
import WashGrid from "../components/WashGrid";
import EntrySetting from "../components/EntrySetting";
import DataTree from "../components/DataTree";
import DropZone from "../components/DropZone";
import Headline from "../components/Headline";
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import {
    isEmpty, getglobaldata, initializedata, Getstorage, Savestorage, NumConv, DeepCopy, isEnabled, CellType,
    getWindowDimensions, setglobaldata, getformid, getcontroller, getsubkey, GetDesitRound, DicVal, RandomKey, customTarget
} from '../modules/appLibrary';
import { cfFileUpload, cfNewUploadFile, cfMargeUploadFiles } from '../modules/commodule';
import { setimagelist } from '../modules/imagedlgstore';
import { arrayMove } from 'react-sortable-hoc';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import EntryLayout from '../components/EntryLayout';
import { changestatus, listtabs, entrytriggercall, reports, applylinkfield} from '../modules/formstore';
import { setentrypanel, addentrylayout, setentrylayout, setentrystartup} from '../modules/toolpanelstore';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@material-ui/core/TextField';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

export const Label = props => {
    const inittag = [
        {
            value: '0',
            label: '本体',
        }
    ];

    const panelsdef = [];
    const G_id = {
        BASE: "0", RAW: "1", COMP: "11", ATTN: "13", DEME: "14", WASH: "wash", NB: "nb", IMAGE: "pic", FILE: "file",
                             COMP2:"21", ATTN2:"23", DEME2:"24", WASH2:"wash2"
    }
    const primarykeys = ["d_label_no", "d_label_raw_key", "d_label_tag_key", "d_label_comp_key","d_label_attn_key", "d_label_deme_key", "d_label_wtag_key"];
    const formid = getformid("Label", props.location.search);
    const controller = getcontroller("Label", props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.accctl);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);
    const CELLTYPE = CellType();

    const AGRef = useRef();
    const fnc = useRef();
    const EntrybodyRef = useRef(null);
    const apiRefraw = useRef({ grid: undefined, column: undefined });
    const apiRefcomp = useRef({ grid: undefined, column: undefined });
    const apiRefcomp2 = useRef({ grid: undefined, column: undefined });
    const apiRefwash = useRef({ grid: undefined, column: undefined });
    const apiRefwash2 = useRef({ grid: undefined, column: undefined });
    const apiRefattn = useRef({ grid: undefined, column: undefined });
    const apiRefattn2 = useRef({ grid: undefined, column: undefined });
    const apiRefdeme = useRef({ grid: undefined, column: undefined });
    const apiRefdeme2 = useRef({ grid: undefined, column: undefined });
    const locationstate = useRef(null);    //遷移State

    const menuinfo = useSelector(state => state.form.menuinfo);
    const formstatus = useSelector(state => state.form.status);
    const entrylock = useSelector(state => state.form.entryformlock);
    const [panel, setpanel] = useState(panelsdef);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [columninfo, setcolumninfo] = useState(null);     //全カラム情報
    const [columns, setcolumns] = useState(null);
    const [edittingcode, setedittingcode] = useState(null);
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [update, setUpdata] = useState(false);
    const [layoutlock, setlayoutlock] = useState(false);
    const [sectionclose, setsectionclose] = useState(false);
    const [isDragActive, setIsDragActive] = useState(false);
    const washnone = useSelector(state => state.menu.washnone);

    const dispatch = useDispatch();
    const AGFunc = React.forwardRef(AGFunction);
    const ComFunc = React.forwardRef(ComFunction);
    const scrollRef = useRef(null);
    const AcceptNo = useRef({ no: "" });
    const search = useLocation().search;
    const reportsRef = useRef(null);
    //変更確認用
    const editcode = useRef("");

    //データ
    const entrydataRef = useRef(null);    
    const rawdataRef = useRef(null);
    const imageRef = useRef(null);
    const fileRef = useRef(null);         //ファイル  
    const compdataRef = useRef(null);
    const compdataRef2 = useRef(null);
    const washdataRef = useRef(null);
    const washdataRef2 = useRef(null);
    const attndataRef = useRef(null);
    const attndataRef2 = useRef(null);
    const demedataRef = useRef(null);
    const demedataRef2 = useRef(null);


    //列情報
    const rawcolRef = useRef(null);
    const compcolRef = useRef(null);
    const compcolRef2 = useRef(null);
    const washcolRef = useRef(null);
    const washcolRef2 = useRef(null);
    const washexcolRef = useRef(null);
    const attncolRef = useRef(null);
    const attncolRef2 = useRef(null);
    const demecolRef = useRef(null);
    const demecolRef2 = useRef(null);
    const coldefRefs = [
        { id: G_id.RAW, ref: rawcolRef, dataref: rawdataRef, api: apiRefraw.current, table: "d_label_raw" },
        { id: G_id.COMP, ref: compcolRef, dataref: compdataRef, api: apiRefcomp.current, table:"d_label_comp" },
        { id: G_id.COMP2, ref: compcolRef2, dataref: compdataRef2, api: apiRefcomp2.current, table: "d_label_comp" },
        { id: G_id.WASH, ref: washcolRef, dataref: washdataRef, api: apiRefwash.current, table:"d_label_wash" },
        { id: G_id.WASH2, ref: washcolRef2, dataref: washdataRef2, api: apiRefwash2.current, table: "d_label_wash" },
        { id: G_id.ATTN, ref: attncolRef, dataref: attndataRef, api: apiRefattn.current, table:"d_label_deme" },
        { id: G_id.ATTN2, ref: attncolRef2, dataref: attndataRef2, api: apiRefattn2.current, table: "d_label_deme" },
        { id: G_id.DEME, ref: demecolRef, dataref: demedataRef, api: apiRefdeme.current, table:"d_label_row" },
        { id: G_id.DEME2, ref: demecolRef2, dataref: demedataRef2, api: apiRefdeme2.current, table: "d_label_row" }
    ];

    function statusKey(id) {
        return formid + "entry_" + id;
    }


    const actionurl = {
        "insert": "label/Insert",
         "update": "label/Update",
         "delete": "label/Delete",
         "saveas": "label/SaveAs",
        "storageadd": "label/AddStorage",
        "storagerowdel": "label/StorageRowdel",
         "upload": "label/Upload",
    }

    const navmenu = [
        { status: "ENTRY FORM", menuid: "formupload", icon: "upload_file", label: "関連ファイルUpload", title: "関連ファイルをアップロードします" },
        { status: "ENTRY FORM", menuid: "sep1" },
        { status: "ENTRY FORM", menuid: "datatree", icon: "account_tree", label: "Data Tree" },
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
        { status: "VIEW", menuid: "sep3" },
        { status: "VIEW", menuid: "upload", icon: "upload_file", label: "関連ファイルUpload", title: "関連ファイルをアップロードします" },
        { status: "VIEW", menuid: "sep4" },
        { status: "VIEW", menuid: "listdatatree", icon: "account_tree", label: "Data Tree" },
    ]

    function rerender() {
        setUpdata(update ? false : true);
    }

    function onDragEnter(e){
        if (entrylock) return;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setIsDragActive(true);
        }
    };
    function FileDropClose() {
        setIsDragActive(false);
    }

    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;
        //ListTabを取得
        fnc.current.postaxios('common/GetListTabs', { "panels": panelsdef, "controller": controller, "subkey": subkey },
            {
                onSuccess: function (data) {
                    setpanel(data.panels);
                    dispatch(reports(data.reports));
                    dispatch(setentrypanel({
                        layouts: data.layouts, prelayout: data.prelayout,
                        initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                        fitColumn: data.fitColumn
                    }));
                    reportsRef.current = data.reports;

                    setcolumninfo(data.colinfo);
                    setcolumns(data.columns);
                    let fields = data.colinfo.filter(e => e.logpid === G_id.BASE);
                    settextfieldsall(fields);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    fnc.current.initMaster(data.master);

                    //列情報初期化
                    for (let i = 0; i < coldefRefs.length; i++) {
                        coldefRefs[i].ref.current = null;
                    }
                    if (data.prelayout) {   //レイアウト復元
                        RestoreLayout(data.panels, fields);
                    }

                    //遷移state取得
                    let state = props.location.state;   //history.push
                    if (isEmpty(state) && !isEmpty(window.history.state)) {
                        if ("status" in window.history.state) {
                            //go back
                            state = window.history.state;
                        }
                    }
                    locationstate.current = state;
                    if (!isEmpty(state)) {
                        if ("code" in state) {
                            clearform();
                            dispatch(changestatus(state.code === "" ? "NEW FORM" : "ENTRY FORM"));
                        }
                    }
                    fnc.current.wait(false);
               }
            });
    }, [search]);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setlayoutlock(menuinfo.ctrls.indexOf("LOCK2") !== -1);
        setsectionclose(menuinfo.ctrls.indexOf("SECCLOSE") !== -1); //セクションCLOSEボタン
    }, [menuinfo]);

    function defaulttaglist() {
        if (isEmpty(DicVal(menuinfo, "otherctrls", null))) return inittag;
        var list = DicVal(menuinfo.otherctrls, "TAGKIND", null);
        if (list === null) return inittag;
        var kinds = [];
        for (let i = 0; i < list.length; i++) {
            var ar = list[i].split(":");
            kinds.push({ value: ar[0], label: ar[1] });
        }
        return kinds;
    }

    useEffect(() => {
        if (formstatus === "COPY FORM") {
            entrydataRef.current["d_label_no"] = "";
            entrydataRef.current["d_label_createac"] = "";
            entrydataRef.current["d_label_createdate"] = "";
            entrydataRef.current["d_label_updateac"] = "";
            entrydataRef.current["d_label_update"] = "";
            rerender();
       }
    }, [formstatus]);


    //遷移state状態表示
    function callshow() {
        if (locationstate.current.code !== "") {
            Show(undefined, locationstate.current.code)
        } else {
            if (!isEmpty(locationstate.current.acceptno)) {
                clearform(true, locationstate.current.acceptno);
            }
        }
        locationstate.current = null;   //最初の１度のみ
    }

    function onFirstDataRendered(param,id) {
        if (id === G_id.RAW) {
            apiRefraw.current.grid = param.api;
            apiRefraw.current.column = param.columnApi;
        }
        if (id === G_id.COMP) {
            apiRefcomp.current.grid = param.api;
            apiRefcomp.current.column = param.columnApi;
        }
        if (id === G_id.COMP2) {
            apiRefcomp2.current.grid = param.api;
            apiRefcomp2.current.column = param.columnApi;
        }
        if (id === G_id.WASH) {
            apiRefwash.current.grid = param.api;
            apiRefwash.current.column = param.columnApi;
        }
        if (id === G_id.WASH2) {
            apiRefwash2.current.grid = param.api;
            apiRefwash2.current.column = param.columnApi;
        }
        if (id === G_id.ATTN) {
            apiRefattn.current.grid = param.api;
            apiRefattn.current.column = param.columnApi;
        }
        if (id === G_id.ATTN2) {
            apiRefattn2.current.grid = param.api;
            apiRefattn2.current.column = param.columnApi;
        }
        if (id === G_id.DEME) {
            apiRefdeme.current.grid = param.api;
            apiRefdeme.current.column = param.columnApi;
        }
        if (id === G_id.DEME2) {
            apiRefdeme2.current.grid = param.api;
            apiRefdeme2.current.column = param.columnApi;
        }
        if (!isEmpty(locationstate.current)) {
            //描画終了を待つ
            let call = true;
            for (let i = 0; i < coldefRefs.length; i++) {
                if (EmptyPanel(coldefRefs[i].id)) continue;
                if (isEmpty(coldefRefs[i].api.grid)) {
                    call = false; break;
                }
            }
            //遷移表示
            if (call) callshow();
        }
    }
    function Show(data, pushcode) {
        let code = "";
        if (data === undefined) {
            if (!isEmpty(pushcode)) {   //history.push
                code = pushcode;
                setedittingcode(code);
            } else {
                code = edittingcode;    //再表示
            }
        } else {
            setglobaldata("entryrowdata",data);
            if (data !== null) {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (data[primarykeys[i]]) {
                        code = data[primarykeys[i]]; break;
                    }
                }
            }
            setedittingcode(code);
        }
        if (isEmpty(columninfo)) return false;    //読み込み前
        clearform(code === "");
        //データ読み込み
        LoadData(code);
        return true;
    }

    function LoadData(code) {
        if (code === "") return;
        fnc.current.postaxios('label/GetData', { "code": code, "colinfo": columninfo, "controller": controller },
            {
                onSuccess: function (data) {
                    try {
                        if (code !== "") {
                            //ViewからのMyField値を引継ぎ
                            let row = getglobaldata("entryrowdata");
                            if (!isEmpty(row)) {
                                if ("d_label_memo" in row) data.data.d_label_memo = row.d_label_memo;
                                if ("d_label_sticky" in row) data.data.d_label_sticky = row.d_label_sticky;
                                if ("d_label_mytags" in row) data.data.d_label_mytags = row.d_label_mytags;
                            }
                        }
                        fnc.current.margeMaster(data.master);
                        entrydataRef.current = data.data;
                        editcode.current = data.data["d_label_prodno"] + data.data["d_label_attribute2"];   //加工依頼No＋組区分

                       //行データ
                        if (data.raw.length !== 0) rawdataRef.current = data.raw;

                        //let tags = defaulttaglist();
                        //if (data.tag.length !== 0) {
                        //    tags = [];
                        //    for (let i = 0; i < data.tag.length; i++) {
                        //        tags.push({ value: data.tag[i].d_label_tag_no, label: data.tag[i].d_label_tag_name });
                        //    }
                        //}
                        if (data.comp.length !== 0) {
                            compdataRef.current = data.comp.filter(e => e.d_label_comp_tag === '0');
                            compdataRef2.current = data.comp.filter(e => e.d_label_comp_tag === '1');
                            if(compdataRef.current.length === 0)compdataRef.current = null;
                            if(compdataRef2.current.length === 0)compdataRef2.current = null;
                        }
                        if (data.wash.length !== 0) {
                            for (let i = 0; i <= 1; i++) {
                                let wash = [];
                                let list = data.wash.filter(e => e.d_label_wtag_tag === i.toString());
                                if (list.length != 0) {
                                    wash.push({
                                        rowid: "0",
                                        mark1: list[0].d_label_wtag_mark1, mark2: list[0].d_label_wtag_mark2, mark3: list[0].d_label_wtag_mark3,
                                        mark4: list[0].d_label_wtag_mark4, mark5: list[0].d_label_wtag_mark5, mark6: list[0].d_label_wtag_mark6,
                                        mark7: list[0].d_label_wtag_mark7
                                    });
                                } else {
                                    wash.push({
                                        rowid: "0",
                                        mark1: washnone, mark2: washnone, mark3: washnone, mark4: washnone, mark5: washnone, mark6: washnone, mark7: washnone
                                    });
                                }
                                if (i === 0) {
                                    washdataRef.current = wash;
                                } else {
                                    washdataRef2.current = wash;
                                }
                            }
                        }
                        //付記用語にカラーをセット
                        SetAttnColor(data.prodcolor);

                        if (data.attn.length !== 0) {
                            attndataRef.current = data.attn.filter(e => e.d_label_attn_tag === '0');
                            attndataRef2.current = data.attn.filter(e => e.d_label_attn_tag === '1');
                            if (attndataRef.current.length === 0) attndataRef.current = null;
                            if (attndataRef2.current.length === 0) attndataRef2.current = null;
                        }
                        if (data.deme.length !== 0) {
                            demedataRef.current = data.deme.filter(e => e.d_label_deme_tag === '0');
                            demedataRef2.current = data.deme.filter(e => e.d_label_deme_tag === '1');
                            if (demedataRef.current.length === 0) demedataRef.current = null;
                            if (demedataRef2.current.length === 0) demedataRef2.current = null;
                        }
                        imageRef.current = data.images;
                        fileRef.current = data.files;
                        dispatch(setimagelist(data.images));

                        //settaglist(tags);
                        //settagno("0");

                        rerender();
                        fnc.current.wait(false);
                    } catch (error) {
                        console.log(error);
                        fnc.current.wait(false);
                    }
               },
                onError: function (data) {
                    fnc.current.wait(false);
                    let msg = "処理に失敗しました";
                    if (!isEmpty(data.errDescription)) {
                        msg = data.errDescription;
                    }
                    fnc.current.warnmsg(msg);
                    dispatch(changestatus("VIEW"));
                }
            }
        )
    }

    function showdata(data) {
        fnc.current.margeMaster(data.master);
        entrydataRef.current = data.data;

        //行データ
        if (data.raw.length !== 0) rawdataRef.current = data.raw;

        //let tags = defaulttaglist();
        //if (data.tag.length !== 0) {
        //    tags = [];
        //    for (let i = 0; i < data.tag.length; i++) {
        //        tags.push({ value: data.tag[i].d_label_tag_no, label: data.tag[i].d_label_tag_name });
        //    }
        //}
        if (data.comp.length !== 0) {
            compdataRef.current = data.comp.filter(e => e.d_label_comp_tag === '0');
            compdataRef2.current = data.comp.filter(e => e.d_label_comp_tag === '1');
        }

        if (data.wash.length !== 0) {
            for (let i = 0; i <= 1; i++) {
                let wash = [];
                let list = data.wash.filter(e => e.d_label_wtag_tag === i);
                if (list.length != 0) {
                    wash.push({
                        rowid: "0",
                        mark1: list[0].d_label_wtag_mark1, mark2: list[0].d_label_wtag_mark2, mark3: list[0].d_label_wtag_mark3,
                        mark4: list[0].d_label_wtag_mark4, mark5: list[0].d_label_wtag_mark5, mark6: list[0].d_label_wtag_mark6,
                        mark7: list[0].d_label_wtag_mark7
                    });
                } else {
                    wash.push({
                        rowid: "0",
                        mark1: washnone, mark2: washnone, mark3: washnone, mark4: washnone, mark5: washnone, mark6: washnone, mark7: washnone
                    });
                }
                if (i === 0) {
                    washdataRef.current = wash;
                } else {
                    washdataRef2.current = wash;
                }
            }
        }
        if (data.attn.length !== 0) {
            attndataRef.current = data.attn.filter(e => e.d_label_attn_tag === '0');
            attndataRef2.current = data.attn.filter(e => e.d_label_attn_tag === '1');
        }
        if (data.deme.length !== 0) {
            demedataRef.current = data.deme.filter(e => e.d_label_deme_tag === '0');
            demedataRef2.current = data.deme.filter(e => e.d_label_deme_tag === '1');
        }

        imageRef.current = data.images;
        fileRef.current = data.files;
        dispatch(setimagelist(data.images));
    //    settaglist(tags);
    //    settagno("0");
    }

    function existPanel(id) {
        let pnl = panel.find(e => e.id === id);
        return pnl !== undefined;
    }
    //リストレイアウト適用
    function SetLayout(newcol, type) {
        let newfields = DeepCopy(textfields.filter(e=>e.type !==type));
        for (let i = 0; i < newcol.length; i++) {
            let column = textfieldsall.find(e => e.columnid === newcol[i]);
            newfields.push(column);
        }
        settextfields(newfields);
   }

    function showpanel(id, type, show) {
        let newpanel = DeepCopy(panel);
        let p = newpanel.find(e => e.id === id && e.type === type);
        p.hide = !show;
        setpanel(newpanel);
    }
    // スクロール位置を保存する
    function saveScrollPos() {
        scrollRef.current = EntrybodyRef.current.scrollTop;
    }
    // スクロール位置を復元する
    function restoreScrollPos() {
        try{
            if (scrollRef.current) EntrybodyRef.current.scrollTop = scrollRef.current;
        }catch{ }
    }
    //行データ保持
    function storeRowData(panel) {
        if (isEmpty(AGRef.current)) return;
        for (let i = 0; i < coldefRefs.length; i++) {
            if (panel === undefined || panel === coldefRefs[i].id) {
                let grid = coldefRefs[i].api.grid;
                coldefRefs[i].dataref.current = AGRef.current.GetDatasource(grid);
            }
        }
    }

    function Jump(id, type) {
        let offset = 0;
        var panelid = "basepanel" + type;
        if (id === G_id.IMAGE) panelid = 'imagepanel';
        if (id === G_id.RAW) panelid = 'rawGrid';
        if (id === G_id.COMP) panelid = 'compGrid';
        if (id === G_id.WASH) panelid = 'washGrid';
        if (id === G_id.ATTN) panelid = 'attnGrid';
        if (id === G_id.DEME) panelid = 'demeGrid';
        if (id === G_id.COMP2) panelid = 'compGrid2';
        if (id === G_id.WASH2) panelid = 'washGrid2';
        if (id === G_id.ATTN2) panelid = 'attnGrid2';
        if (id === G_id.DEME2) panelid = 'demeGrid2';
        if (id === G_id.FILE) panelid = 'fileGrid';
        if (id === G_id.NB) panelid = 'remarkspanel' + type;
        let elem = document.getElementById(panelid);
        if (elem === undefined) return;
        offset = elem.offsetTop - 50;
        EntrybodyRef.current.scrollTop = offset;
    }

    function MenuQueryAction(action, param) {
        return true;
    }
    function MenuAction(action, finallycallback, param) {
        LayoutSavestorage();   //現在レイアウト保持
        if (action === 'save') Save(finallycallback);
        if (action === 'delete') Delete(finallycallback);
        if (action === "clear") clearform(true);
        if (action === 'linkfield') {
            if (finallycallback.table === "d_label" || finallycallback.type === "100") {
                let type = "100";
                let col = textfields.find(e => e.columnid === finallycallback.field);
                if (col !== undefined) {
                    type = col.type;
                    let key = finallycallback.field + "_" + type;
                    document.getElementById(key).focus();
                    document.getElementById(key).select();
                }
                Jump(G_id.BASE, type);
                return;
            }
            let target = coldefRefs.find(e => e.table === finallycallback.table);
            if (isEmpty(target)) return;
            Jump(target.id);
            AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, target.api.grid);
        }
        if (reportsRef.current.some(e => e.id === action)) {   //帳票
            let code = [];
            if (formstatus === "ENTRY FORM") {
                code = [edittingcode];
            } else {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (primarykeys[i] in param[0]) {
                        for (let j = 0; j < param.length; j++) {
                            code.push(param[j][primarykeys[i]]);
                        }
                        break;
                    }
                }
            }
            if (code.length === 0) return;
            fnc.current.postaxios('common/Printout', { controller: controller, id: action, keys: code },
                {
                    onSuccess: function (data) {
                        let params = {
                            "excelfile": data.returnData["filename"],
                            "dnfile": data.returnData["dnfile"]
                        }
                        fnc.current.filedownload("excel/ExcelDownload", params);
                        fnc.current.wait(false);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
            return;
        }
        if (action === 'datatree') {
            DataTreeOpen(edittingcode);
        }
        if (action === 'listdatatree') {
            for (let i = 0; i < primarykeys.length; i++) {
                if (primarykeys[i] in param[0]) {
                    setedittingcode(param[0][primarykeys[i]]);
                    DataTreeOpen(param[0][primarykeys[i]]);
                    return;
                }
            }
        }
        function DataTreeOpen(code) {
            fnc.current.postaxios('label/GetDataTree', { "controller": controller, "code": code, "colinfo": columninfo },
                {
                    onSuccess: function (data) {
                        fnc.current.wait(false);
                        fnc.current.datatreeopen(data.list);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
        }
    }
    function Save(finallycallback) {
        var newfiles = (formstatus === "ENTRY FORM" ? [] : cfNewUploadFile(imageRef, fileRef)); //v1.4
        if (newfiles.length > 10) {
            fnc.current.warnmsg("新規登録できるアップロードファイル数は10までです。");
            return;
        }
        storeRowData();

        //Tag固定
        let tags = [];
        tags.push({ value: 0, label: "タグ１" });
        tags.push({ value: 1, label: "タグ２" });

        let comp = [];
        if (!EmptyPanel(G_id.COMP)) {
            for (let i = 0; i < compdataRef.current.length; i++) {
                compdataRef.current[i]["d_label_comp_tag"] = "0";
                comp.push(compdataRef.current[i]);
            }
            for (let i = 0; i < compdataRef2.current.length; i++) {
                compdataRef2.current[i]["d_label_comp_tag"] = "1";
                comp.push(compdataRef2.current[i]);
            }
        }
        let wash = [];
        if (existPanel(G_id.WASH)) {
            for (let i = 0; i < washdataRef.current.length; i++) {
                washdataRef.current[i]["d_label_wtag_tag"] = "0";
                wash.push(washdataRef.current[i]);
            }
            for (let i = 0; i < washdataRef2.current.length; i++) {
                washdataRef2.current[i]["d_label_wtag_tag"] = "1";
                wash.push(washdataRef2.current[i]);
            }
        }
        let attn = [];
        if (!EmptyPanel(G_id.ATTN)) {
            for (let i = 0; i < attndataRef.current.length; i++) {
                attndataRef.current[i]["d_label_attn_tag"] = "0";
                attn.push(attndataRef.current[i]);
            }
            for (let i = 0; i < attndataRef2.current.length; i++) {
                attndataRef2.current[i]["d_label_attn_tag"] = "1";
                attn.push(attndataRef2.current[i]);
            }
        }
        let deme = [];
        if (!EmptyPanel(G_id.DEME)) {
            for (let i = 0; i < demedataRef.current.length; i++) {
                demedataRef.current[i]["d_label_deme_tag"] = "0";
                deme.push(demedataRef.current[i]);
            }
            for (let i = 0; i < demedataRef2.current.length; i++) {
                demedataRef2.current[i]["d_label_deme_tag"] = "1";
                deme.push(demedataRef2.current[i]);
            }
        }
        const paramdata = {
            "controller": controller,
            "data": entrydataRef.current,
            "raw": EmptyPanel(G_id.RAW) ? null : rawdataRef.current,
            "tag": tags,
            "comp": EmptyPanel(G_id.COMP) ? null :comp,
            "wash": EmptyPanel(G_id.WASH) ? null : wash,
            "attn": EmptyPanel(G_id.ATTN) ? null : attn,
            "deme": EmptyPanel(G_id.DEME) ? null : deme,
            "images": imageRef.current,
            "files": fileRef.current,
            "colinfo": columninfo,
            "code": edittingcode
        }

        fnc.current.postaxios(formstatus === "ENTRY FORM" ? "label/UpdateEntry" : "label/InsertEntry", paramdata,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.modify(false);
                        let code = data.request;
                        if (formstatus !== "ENTRY FORM") {
                            entrydataRef.current["m_label_code"] = data.request;
                            setedittingcode(data.request);
                            dispatch(changestatus("ENTRY FORM"));
                        }
                        if (newfiles.length !== 0) {        //v1.4
                            //新規ファイルアップロード
                            cfFileUpload("label", code, newfiles, fnc, () => LoadData(code));
                        } else {
                            fnc.current.success();
                            if (formstatus === "ENTRY FORM") {
                                data.data['rowid'] = Getrowid();    //更新行キー
                                finallycallback(data.data);
                            }
                            LoadData(code);     //再表示
                        }
                    }
                    else {
                        let msg = data.warning.length + "件の制約違反により登録できませんでした。";
                        fnc.current.showwarndescription(msg, data.warning);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "登録に失敗しました"
            }
        )
    }
    function Delete(finallycallback) {
        const param = {
            rowdata: [{ "rowid": edittingcode }],
            controller: controller
        }
        fnc.current.postaxios("label/Delete", param,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.success();
                        finallycallback(edittingcode, primarykeys);
                    }
                    else {
                        fnc.current.warnmsg(["このデータは削除できません", data.warning[0].message]);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "削除に失敗しました"
            }
        )
    }
    function Getrowid() {
        let data = getglobaldata("entryrowdata");
        if (isEmpty(data)) return "";
        return data.rowid;
    }
    //入力フィールドクリア
    function clearform(newform, acceptno) {
        editcode.current = "";
        entrydataRef.current = initializedata(textfieldsall, staff);
        rawdataRef.current = null;
        compdataRef.current = null;
        compdataRef2.current = null;
        washdataRef.current = null;
        washdataRef2.current = null;
        attndataRef.current = null;
        attndataRef2.current = null;
        demedataRef.current = null;
        demedataRef2.current = null;
        imageRef.current = null;
        fileRef.current = null;
        AcceptNo.current.no = "";

        SetAttnColor([]);   //付記のC/#を削除
        scrollRef.current = null;
        dispatch(setimagelist([]));
        //settaglist(defaulttaglist());
        //settagno("0");
        fnc.current.modify(false);

        if (isEnabled(newform)) {
            //SQL初期値セット
            fnc.current.postaxios("common/GetInitSqlValue", { colinfo: textfieldsall },
                {
                    onSuccess: function (data) {
                        for (let key in data.returnData) {
                            var col = textfieldsall.find(e => e.columnid === key);
                            if (!isEmpty(col)) col.initvalue = data.returnData[key];
                        }
                        entrydataRef.current = initializedata(textfieldsall, staff);
                        entrydataRef.current["d_label_prodno"] = acceptno;
                        if (!isEmpty(acceptno)) {
                            dispatch(applylinkfield("d_label_prodno"));
                        } else {
                            rerender();     //これにより組成初期値がセットされない
                        }
                    },
                }, true
            )
        }

    }

    function GridColDef(id) {
        return coldefRefs.find(e => e.id === id).ref.current;
    }
    //付記用語にカラーをセット
    function SetAttnColor(colors) {
        for (let i = 0; i < 2; i++) {
            let id = G_id.ATTN;
            if (i === 1) id = G_id.ATTN2;
            if (EmptyPanel(id)) continue;
            var coldef = GridColDef(id);
            if (isEmpty(coldef)) continue;
            let defcol = coldef.filter(e => e.field.indexOf("__col") === -1);
            for (let c = 0; c < colors.length; c++) {
                let colno = colors[c];
                let column =
                {
                    headerName: colno,
                    field: "__col" + colno,
                    colId: "__col" + colno,
                    editable: true,
                    width: 50,
                    colinfo: { datatype: CELLTYPE.CHECK, columnid: "__col" + colno }
                }
                defcol.push(column);
            }
            const newdef = [...defcol];
            if (newdef.length > 4) {
                //付記用語名を末尾に移動
                const [movedRow] = newdef.splice(3, 1);
                newdef.push(movedRow);
            }
            if (i === 0) attncolRef.current = newdef; 
            if (i === 1) attncolRef2.current = newdef; 
        }
    }

    //基本項目設定
    function SetBaseField(type) {
        fnc.current.entrylayoutopen(type);
    }
    //レイアウト復元
    function RestoreLayout(panels, fields) {
        //パネルの並び
        RestorePanel(panels);
        //基本情報
        RestoreBase(fields)
    }
    function RestorePanel(panel) {
        let paneldata = Getstorage(corpkey, account, formid + "panel");
        if (isEmpty(paneldata)) return;
        if (panel.length !== paneldata.length) return;
        for (let i = 0; i < paneldata.length; i++) {
            let item = panel.find(e => e.id === paneldata[i].id && e.type === paneldata[i].type);
            if (isEmpty(item)) return;
            paneldata[i].name = item.name;
            paneldata[i].name2 = item.name2;
            paneldata[i].abbr = item.abbr;
        }
        setpanel(paneldata);
    }
    function RestoreBase(fields) {
        const baseinfo = Getstorage(corpkey, account, statusKey(G_id.BASE));
        if (isEmpty(baseinfo)) return;
        let newdata = [];
        for (let i = 0; i < baseinfo.length; i++) {
            let item = fields.find(e => e.table === baseinfo[i].table && e.columnid === baseinfo[i].columnid);
            if (isEmpty(item)) return;
            newdata.push(item);
        }
        settextfields(newdata);
    }
    //レイアウト保持
    function LayoutSavestorage() {
        //列情報保存
        for (let i = 0; i < coldefRefs.length; i++) {
            AGRef.current.SaveColState(statusKey(coldefRefs[i].id), EmptyPanel(coldefRefs[i].id) ? null : coldefRefs[i].column);
        }
        //基本情報保存
        Savestorage(corpkey, account, statusKey(G_id.BASE), textfields);
        //パネルの表示/非表示および並び
        Savestorage(corpkey, account, formid + "panel", panel);
    }

    //レイアウト登録
    function SaveLayout(layoutid) {
        let setbase = false;
        let coldef = [];
        for (let p = 0; p < panel.length; p++) {
            var cols = [];
            switch (panel[p].id) {
                case G_id.BASE:
                    if (setbase) break;
                    let fds = textfields.filter(x => !x.hide);
                    for (let f = 0; f < fds.length; f++) {
                        coldef.push({
                            headerName: fds[f].columnnm, table: fds[f].table, field: fds[f].columnid, width: fds[f].width,
                            type:fds[f].type
                        });
                    }
                    setbase = true;
                    break;
                case G_id.RAW:
                    cols = AGRef.current.GetshownColDef(apiRefraw.current.column);
                    break;
                case G_id.COMP:
                    cols = AGRef.current.GetshownColDef(apiRefcomp.current.column);
                    break;
                case G_id.COMP2:
                    cols = AGRef.current.GetshownColDef(apiRefcomp2.current.column);
                    break;
                case G_id.ATTN:
                    cols = AGRef.current.GetshownColDef(apiRefattn.current.column);
                    break;
                case G_id.ATTN2:
                    cols = AGRef.current.GetshownColDef(apiRefattn2.current.column);
                    break;
                case G_id.DEME:
                    cols = AGRef.current.GetshownColDef(apiRefdeme.current.column);
                    break;
                case G_id.DEME2:
                    cols = AGRef.current.GetshownColDef(apiRefdeme2.current.column);
                    break;
                default:
                    continue;
            }
            if (panel[p].id !== G_id.BASE) {
                for (let i = 0; i < cols.length; i++) {
                    let col = DeepCopy(cols[i]);
                    col.type = tabletype(panel[p].id);
                    coldef.push(col);
                }
            }
        }
        fnc.current.postaxios('common/SaveLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
                coldef: coldef,
                panels: panel
            },
            {
                onSuccess: function (data) {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(addentrylayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト削除
    function DeleteLayout(layoutid) {
        fnc.current.postaxios('common/DeleteEntryLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    let newlayout = mainlayout.filter(function (val) { return val.value !== layoutid; });
                    dispatch(setentrylayout(newlayout));
                    if (data.request !== maininitlayout)
                        dispatch(setentrystartup({
                            prelayout: mainprelayout,
                            initlayout: " ",
                            fitColumn: false
                        }));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト呼び出し
    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    //列情報初期化
                    for (let i = 0; i < coldefRefs.length; i++) {
                        coldefRefs[i].ref.current = null;
                    //    var type = tabletype(coldefRefs[i].id);
                    //    var coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), data.columns.filter(e => e.type === type), false);
                    //    if (coldefRefs[i].length === 0) continue;
                    //    coldefRefs[i].ref.current = coldef;
                    }
                    setpanel(data.panels);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    setcolumns(data.columns);
                    fnc.current.wait(false);
                },
            }
        )
    }

    //リスト編集セル制御
    function ListlockCell(params, edit, status, tabvalue) {
        if (status === "INSERT") {
            //自テーブル以外編集不可
            if (tabvalue !== params.colDef.colinfo.type) return false;
        }
        return edit;
    }


    //パネル別列情報取得
    function tabletype(id) {
        if (id === G_id.WASHEX) {
            if (isEmpty(columninfo)) return "";
            let col = columninfo.find(e => e.logpid === id);
            if (isEmpty(col)) return '';
            return col.type;
        }
        let pnl = panel.find(e => e.id === id);
        if (isEmpty(pnl)) return '';
        return pnl.type;
    }

    //ケアラベル
    //function caralabelAction(mode) {
    //    if (mode === 0) {
    //        fnc.current.formdialogopen({
    //            title: "ケアラベル追加", inputname: "ラベル名", dialogtype: 0,
    //            placeholder: "ラベル名を入力してください",
    //            onApply: (value)=>exec(value)
    //        });
    //        function exec(value) {
    //            if (taglist.find(e => e.label === value) !== undefined) {
    //                fnc.current.warnmsg("同一ラベル名が存在します");
    //                return;
    //            } else {
    //                let no = value;
    //                while (true) {
    //                    if (taglist.find(e => e.value === no) === undefined) break;
    //                    no += "1";
    //                }
    //                let newlist = taglist.concat([{
    //                    label: value,
    //                    value: no
    //                }]);
    //                setcarelabel(no, newlist);
    //                fnc.current.formdialogclose();
    //            }
    //        }
    //    }
    //    if (mode === 1) {
    //        if (taglist.length === 1) {
    //            fnc.current.warnmsg("このケアラベルは削除できません");
    //            return;
    //        }
    //        fnc.current.confmsg("表示中のケアラベルを削除します。よろしいですか？", () => exec());
    //        function exec() {
    //            let data = compbytagRef.current.filter(e => e.no !== tagnoRef.current);
    //            compbytagRef.current = data;
    //            data = washbytagRef.current.filter(e => e.no !== tagnoRef.current);
    //            washbytagRef.current = data;
    //            data = attnbytagRef.current.filter(e => e.no !== tagnoRef.current);
    //            attnbytagRef.current = data;
    //            data = demebytagRef.current.filter(e => e.no !== tagnoRef.current);
    //            demebytagRef.current = data;
    //            let newlist = taglist.filter(e => e.value !== tagnoRef.current);
    //            setcarelabel(newlist[0].value, newlist);
    //        }
    //    }
    //    if (mode === 2) {
    //        let tag = taglist.find(e => e.value === tagnoRef.current);
    //        fnc.current.formdialogopen({
    //            title: "ケアラベル名の変更", inputname: "ラベル名", dialogtype: 0,
    //            defaultvalue: tag.label,
    //            placeholder: "ラベル名を入力してください",
    //            onApply: (value) => exec(value)
    //        });
    //        function exec(value) {
    //            if (taglist.find(e => e.label === value) !== undefined) {
    //                fnc.current.warnmsg("同一ラベル名が存在します");
    //                return;
    //            } else {
    //                tag.label = value;
    //                let newlist = DeepCopy(taglist);
    //                //setcarelabel(tagnoRef.current, newlist, true);
    //                settaglist(newlist);
    //                fnc.current.formdialogclose();
    //           }
    //        }
    //    }
    //}

    //function setcarelabel(no, always) {
    //    storeRowData();
    //    if (no !== tagnoRef.current || isEnabled(always)) {
    //        compdataRef.current = null;
    //        washdataRef.current = null;
    //        attndataRef.current = null;
    //        demedataRef.current = null;
    //        //該当ケアラベルデータをセット
    //        if (!isEmpty(apiRefcomp.current.grid)) {
    //            let row = compbytagRef.current.find(e => e.no === no);
    //            if (!isEmpty(row)) {
    //                compdataRef.current = row.data;
    //                if (row.data.length === 0) compdataRef.current = [{ rowid: RandomKey() }]
    //            } else {
    //                compdataRef.current = [{ rowid: RandomKey() }]
    //            }
    //            fnc.current.rerenderGrid(G_id.COMP);
    //        }
    //        if (!isEmpty(apiRefwash.current.grid)) {
    //            let row = washbytagRef.current.find(e => e.no === no);
    //            if (!isEmpty(row)) washdataRef.current = row.data;
    //            fnc.current.rerenderGrid(G_id.WASH);
    //        }
    //        if (!isEmpty(apiRefattn.current.grid)) {
    //            let row = attnbytagRef.current.find(e => e.no === no);
    //            if (!isEmpty(row)) {
    //                attndataRef.current = row.data;
    //                if (row.data.length === 0) attndataRef.current = [{ rowid: RandomKey() }]
    //            } else {
    //                attndataRef.current = [{ rowid: RandomKey() }]
    //            }
    //            fnc.current.rerenderGrid(G_id.ATTN);
    //        }
    //        if (!isEmpty(apiRefdeme.current.grid)) {
    //            let row = demebytagRef.current.find(e => e.no === no);
    //            if (!isEmpty(row)) {
    //                demedataRef.current = row.data;
    //                if (row.data.length === 0) demedataRef.current = [{ rowid: RandomKey() }]
    //            } else {
    //                demedataRef.current = [{ rowid: RandomKey() }]
    //            }
    //            fnc.current.rerenderGrid(G_id.DEME);
    //        }

    //        settagno(no);
    //    }
    //}
    //function settagno(no) {
    //    tagnoRef.current = no;
    //   if (!isEmpty(childRef(G_id.COMP))) childRef(G_id.COMP).current?.settagno(no);
    //    if (!isEmpty(childRef(G_id.WASH))) childRef(G_id.WASH).current?.settagno(no);
    //    if (!isEmpty(childRef(G_id.ATTN))) childRef(G_id.ATTN).current?.settagno(no);
    //    if (!isEmpty(childRef(G_id.DEME))) childRef(G_id.DEME).current?.settagno(no);
    //}

    //File Upload 再表示
    function fileuploaded(data) {
        let duplicate = false;
        if (formstatus === 'NEW FORM' || formstatus === 'COPY FORM') {  //v1.4
            if (cfMargeUploadFiles(imageRef, data.images)) duplicate = true;
            if (cfMargeUploadFiles(fileRef, data.files)) duplicate = true;
        } else {
            imageRef.current = data.images;
            fileRef.current = data.files;
        }
        dispatch(setimagelist(imageRef.current));
        rerender();
        //v1.4
        if (duplicate) fnc.current.warnmsg("同名のファイルが存在しました。差し替える場合は元のファイルを削除してからアップロードしてください");
   }

    //リストValueChange
    function ListCellChange(params, columninfo, tabvalue) {
        //簡易計算処理
        var data = null;
        var amountcalc = false;
        if (params.column.colId === "d_label_raw_baseqty" || params.column.colId === "d_label_raw_loss") {
            if (columninfo.some(e => e.columnid === "d_label_raw_baseqty" && e.type === tabvalue) &&
                columninfo.some(e => e.columnid === "d_label_raw_qty" && e.type === tabvalue) &&
                columninfo.some(e => e.columnid === "d_label_raw_loss" && e.type === tabvalue)) {
                //d_label_raw_qty＝d_label_raw_baseqty×(1 + (d_label_raw_loss / 100))
                let col = columninfo.find(e => e.columnid === "d_label_raw_qty" && e.type === tabvalue);
                let qty = NumConv(params.node.data["d_label_raw_baseqty"]) * (1 + (NumConv(params.node.data["d_label_raw_loss"]) / 100));
                qty = GetDesitRound(qty, col.rounding, col.decimalplace);
                data = { d_label_raw_qty: qty }
                amountcalc = true;
            }
        }
        if (params.column.colId === "d_label_raw_rate" || params.column.colId === "d_label_raw_currency") {
            if (columninfo.some(e => e.columnid === "d_label_raw_rate" && e.type === tabvalue) &&
                columninfo.some(e => e.columnid === "d_label_raw_currency" && e.type === tabvalue) &&
                columninfo.some(e => e.columnid === "d_label_raw_price" && e.type === tabvalue)) {
                //d_label_raw_price＝d_label_raw_rate×d_label_raw_currency
                if (NumConv(params.node.data["d_label_raw_rate"]) !== 0 && NumConv(params.node.data["d_label_raw_currency"]) !== 0) {
                    let col = columninfo.find(e => e.columnid === "d_label_raw_price" && e.type === tabvalue);
                    let price = NumConv(params.node.data["d_label_raw_rate"]) * NumConv(params.node.data["d_label_raw_currency"]);
                    price = GetDesitRound(price, col.rounding, col.decimalplace);
                    if (data === null) {
                        data = { d_label_raw_price: price }
                    } else {
                        data['d_label_raw_price'] = price;
                    }
                    amountcalc = true;
                }
            }
        }
        if (params.column.colId === "d_label_raw_price" || amountcalc) {
            if (columninfo.some(e => e.columnid === "d_label_raw_price" && e.type === tabvalue) &&
                columninfo.some(e => e.columnid === "d_label_raw_qty" && e.type === tabvalue) &&
                columninfo.some(e => e.columnid === "d_label_raw_amount" && e.type === tabvalue)) {
                //d_label_raw_amount=d_label_raw_qty*d_label_raw_price
                let col = columninfo.find(e => e.columnid === "d_label_raw_amount" && e.type === tabvalue);
                let amount = NumConv(params.node.data["d_label_raw_qty"]) * NumConv(params.node.data["d_label_raw_price"]);
                amount = GetDesitRound(amount, col.rounding, col.decimalplace);
                if (data === null) {
                    data = { d_label_raw_amount: amount }
                } else {
                    data['d_label_raw_amount'] = amount;
                }
            }
        }
       return data;
    }

    //Grid Data Change
    function ChangeRowValue(params, id) {
        var amountcalc = false;
        if (id === G_id.RAW) {
            if (params.column.colId === "d_label_raw_baseqty" || params.column.colId === "d_label_raw_loss") {
                if (columninfo.some(e => e.columnid === "d_label_raw_baseqty" && e.logpid === id) &&
                    columninfo.some(e => e.columnid === "d_label_raw_qty" && e.logpid === id) &&
                    columninfo.some(e => e.columnid === "d_label_raw_loss" && e.logpid === id) ) {
                    //d_label_raw_qty＝d_label_raw_baseqty×(1 + (d_label_raw_loss / 100))
                    let col = columninfo.find(e => e.columnid === "d_label_raw_qty" && e.logpid === id);
                    let qty = NumConv(params.node.data["d_label_raw_baseqty"]) * (1 + (NumConv(params.node.data["d_label_raw_loss"]) / 100));
                    qty = GetDesitRound(qty, col.rounding, col.decimalplace);
                    let node = params.api.getRowNode(params.node.data["rowid"]);
                    node.setDataValue("d_label_raw_qty", qty);
                    amountcalc = true;
                }
            }
            if (params.column.colId === "d_label_raw_rate" || params.column.colId === "d_label_raw_currency") {
                if (columninfo.some(e => e.columnid === "d_label_raw_rate" && e.logpid === id) &&
                    columninfo.some(e => e.columnid === "d_label_raw_currency" && e.logpid === id) &&
                    columninfo.some(e => e.columnid === "d_label_raw_price" && e.logpid === id)) {
                    //d_label_raw_price＝d_label_raw_rate×d_label_raw_currency
                    if (NumConv(params.node.data["d_label_raw_rate"]) !== 0 && NumConv(params.node.data["d_label_raw_currency"]) !== 0) {
                        let col = columninfo.find(e => e.columnid === "d_label_raw_price" && e.logpid === id);
                        let price = NumConv(params.node.data["d_label_raw_rate"]) * NumConv(params.node.data["d_label_raw_currency"]);
                        price = GetDesitRound(price, col.rounding, col.decimalplace);
                        let node = params.api.getRowNode(params.node.data["rowid"]);
                        node.setDataValue("d_label_raw_price", price);
                        amountcalc = true;
                    }
                }
            }
            if (params.column.colId === "d_label_raw_price" || amountcalc) {
                if (columninfo.some(e => e.columnid === "d_label_raw_price" && e.logpid === id) &&
                    columninfo.some(e => e.columnid === "d_label_raw_qty" && e.logpid === id) &&
                    columninfo.some(e => e.columnid === "d_label_raw_amount" && e.logpid === id) ){
                    //d_label_raw_amount=d_label_raw_qty*d_label_raw_price
                    let col = columninfo.find(e => e.columnid === "d_label_raw_amount" && e.logpid === id);
                    let amount = NumConv(params.node.data["d_label_raw_qty"]) * NumConv(params.node.data["d_label_raw_price"]);
                    amount = GetDesitRound(amount, col.rounding, col.decimalplace);
                    let node = params.api.getRowNode(params.node.data["rowid"]);
                    node.setDataValue("d_label_raw_amount", amount);
                }
            }
        }
        storeRowData(id);
    }

    //ダイドー仕様
    function WashChange(id, param) {
        if (!customTarget(corpkey, 'daidoh')) return;
        if (param.column.colId === "mark1" && param.newValue ==="1") {
            //洗い方が1の場合塩素=1、タンブル=1,干し方=0をセット
            if (id === G_id.WASH) {
                washdataRef.current[0]['mark2'] = "1"
                washdataRef.current[0]['mark3'] = "1"
                washdataRef.current[0]['mark4'] = "0"
            }
            if (id === G_id.WASH2) {
                washdataRef2.current[0]['mark2'] = "1"
                washdataRef2.current[0]['mark3'] = "1"
                washdataRef2.current[0]['mark4'] = "0"
            }
            fnc.current.rerenderGrid(id);
        }
    }

    //Basic Data Change
    function ValueChanged(id, value) {
        //外部からの参照がある項目
        let col = columninfo.find(e => e.columnid === id);
        if (!isEmpty(col)) {
            if (col.extriggerref) {
                dispatch(entrytriggercall(id));
            }
        }

        if ((formstatus === 'NEW FORM' || formstatus === 'COPY FORM') && customTarget(corpkey, 'daidoh')) {
            if ((id === 'd_label_prodno' && !isEmpty(value)) || id === 'd_label_attribute2') {
                if (isEmpty(entrydataRef.current['d_label_prodno'])) return;
                var key = entrydataRef.current['d_label_prodno'] + entrydataRef.current['d_label_attribute2'];
                if (editcode.current !== key) {
                    editcode.current = key;
                    //主素材の組成情報を取得し品質表示①にセット 付属明細の組成情報を取得し品質表示②にセット
                    fnc.current.postaxios('label/GetCompData',
                        {
                            code: entrydataRef.current['d_label_prodno'],
                            type: entrydataRef.current['d_label_attribute2'],
                            controller: controller,
                            colinfo: columninfo,
                        },
                        {
                            onSuccess: function (data) {
                                fnc.current.margeMaster(data.master);
                                let comp = data.comp.filter(e => e.d_label_comp_tag === '0');
                                if (comp.length === 0) {
                                    comp = [{ rowid: "row0" }];
                                }
                                compdataRef.current = comp;
                                comp = data.comp.filter(e => e.d_label_comp_tag === '1');
                                if (comp.length === 0) {
                                    comp = [{ rowid: "row0" }];
                                }
                                compdataRef2.current = comp;
                                SetAttnColor(data.prodcolor);
                                fnc.current.rerenderGrid(G_id.COMP);
                                fnc.current.rerenderGrid(G_id.COMP2);
                                fnc.current.rerenderGrid(G_id.ATTN);
                                fnc.current.rerenderGrid(G_id.ATTN2);
                                fnc.current.wait(false);
                            },
                        }
                    )
                }
            }
        }
    }
    //panel入れ替え
    const onPanelSortEnd = ({ oldIndex, newIndex }) => {
        let items = panel.filter(e => !panelhidden(e));
        let oldidx = panel.findIndex(e => e.type === items[oldIndex].type);
        let newidx = panel.findIndex(e => e.type === items[newIndex].type);
        setpanel(arrayMove(panel, oldidx, newidx));
    };

    //パネルセレクタ
    function panelnavwidth() {
        return windowDimensions.width - 280;
    }
    const SortablePanelItem = SortableElement(({ pnl }) => (
        <ListItem className="minwidth0">
            <Chip
                label={pnl.abbr}
                title={pnl.name}
                size="small"
                onClick={() => Jump(pnl.id, pnl.type)}
            />
        </ListItem>
    ));
    const SortablePanelSelector = SortableContainer(({ items }) => {
        var newitem = [];
        for (let i = 0; i < items.length; i++) {
            if (!panelhidden(items[i])) newitem.push(items[i]);
        }
        return (
            <ul style={{ display: 'flex' }}  >
                {newitem.map((value, index) => (
                    <SortablePanelItem key={`item-${index}`} index={index} pnl={value} disabled={layoutlock}/>
                ))}
            </ul>
        );
    });

    function Contents(props) {
        if (props.panel.id === "0") {
            const baseid = "basepanel" + props.panel.type;
            return (
                <div id={baseid} >
                    <EntryBase
                        fnc={fnc}
                        textfields={textfields}
                        settextfields={settextfields}
                        panel={props.panel}
                        ValueChanged={ValueChanged}
                        entrydataRef={entrydataRef}
                        layoutlock={layoutlock}
                    />
                </div>
            );
        }
        if (props.panel.id === G_id.IMAGE) {
            return (
                <EntryImages
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={imageRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.id === G_id.RAW) {
            return (
                <EntryGrid
                    id={props.panel.id}
                    elemid="rawGrid"
                    entrydataRef={entrydataRef}
                    dataRef={rawdataRef}
                    columnRef={rawcolRef}
                    columninfo={columninfo}
                    columns={columns}
                    type={tabletype(G_id.RAW)}
                    fnc={fnc}
                    onFirstDataRendered={onFirstDataRendered}
                    statusKey={statusKey(G_id.RAW)}
                    ValueChanged={(e) => ChangeRowValue(e, G_id.RAW)}
                    RowValueChanged={() => storeRowData(G_id.RAW)}
                    RemoveRow={() => storeRowData(G_id.RAW)}
                    panel={props.panel}
                />
            );
        }
        if (props.panel.id === G_id.COMP) {
            return (
                <EntryGrid
                    id={props.panel.id}
                    elemid="compGrid"
                    entrydataRef={entrydataRef}
                    dataRef={compdataRef}
                    columnRef={compcolRef}
                    columninfo={columninfo}
                    columns={columns}
                    type={tabletype(G_id.COMP)}
                    fnc={fnc}
                    onFirstDataRendered={onFirstDataRendered}
                    statusKey={statusKey(G_id.COMP)}
                    ValueChanged={() => storeRowData(G_id.COMP)}
                    RowValueChanged={() => storeRowData(G_id.COMP)}
                    RemoveRow={() => storeRowData(G_id.COMP)}
                    panel={props.panel}
                />
            );
        }
        if (props.panel.id === G_id.COMP2) {
            return (
                <EntryGrid
                    id={props.panel.id}
                    elemid="compGrid2"
                    entrydataRef={entrydataRef}
                    dataRef={compdataRef2}
                    columnRef={compcolRef2}
                    columninfo={columninfo}
                    columns={columns}
                    type={tabletype(G_id.COMP2)}
                    fnc={fnc}
                    onFirstDataRendered={onFirstDataRendered}
                    statusKey={statusKey(G_id.COMP2)}
                    ValueChanged={() => storeRowData(G_id.COMP2)}
                    RowValueChanged={() => storeRowData(G_id.COMP2)}
                    RemoveRow={() => storeRowData(G_id.COMP2)}
                    panel={props.panel}
                />
            );
        }
        if (props.panel.id === G_id.WASH ) {
            return (
                <React.Fragment>
                <WashGrid
                    id={props.panel.id}
                    elemid="washGrid"
                    table="d_label_wash"
                    dataRef={washdataRef}
                    columnRef={washcolRef}
                    type={tabletype(G_id.WASH)}
                    fnc={fnc}
                    onFirstDataRendered={onFirstDataRendered}
                    ValueChanged={(e)=>WashChange(props.panel.id,e)}
                    RowValueChanged={() => storeRowData(G_id.WASH)}
                    RemoveRow={() => storeRowData(G_id.WASH)}
                />
                    {EmptyPanel(G_id.WASHEX) ? null :
                        <EntryGrid
                            id={"T" + props.panel.id}
                            elemid="washexGrid"
                            dataRef={washdataRef}
                            columnRef={washexcolRef}
                            columninfo={columninfo}
                            columns={columns}
                            type={tabletype(G_id.WASHEX)}
                            fnc={fnc}
                            onFirstDataRendered={onFirstDataRendered}
                            ValueChanged={() => storeRowData(G_id.WASHEX)}
                            statusKey={formid + "entry_" + G_id.WASHEX}
                            total={true}
                            nogriptitle={true}
                        />
                    }
                </React.Fragment>
            );
        }
        if (props.panel.id === G_id.WASH2) {
            return (
                <React.Fragment>
                    <WashGrid
                        id={props.panel.id}
                        elemid="washGrid2"
                        table="d_label_wash"
                        dataRef={washdataRef2}
                        columnRef={washcolRef2}
                        type={tabletype(G_id.WASH2)}
                        fnc={fnc}
                        onFirstDataRendered={onFirstDataRendered}
                        ValueChanged={(e) => WashChange(props.panel.id, e)}
                        RowValueChanged={() => storeRowData(G_id.WASH2)}
                        RemoveRow={() => storeRowData(G_id.WASH2)}
                    />
                    {EmptyPanel(G_id.WASHEX) ? null :
                        <EntryGrid
                            id={"T" + props.panel.id}
                            elemid="washexGrid"
                            dataRef={washdataRef}
                            columnRef={washexcolRef}
                            columninfo={columninfo}
                            columns={columns}
                            type={tabletype(G_id.WASHEX)}
                            fnc={fnc}
                            onFirstDataRendered={onFirstDataRendered}
                            ValueChanged={() => storeRowData(G_id.WASHEX)}
                            statusKey={formid + "entry_" + G_id.WASHEX}
                            total={true}
                            nogriptitle={true}
                        />
                    }
                </React.Fragment>
            );
        }
        if (props.panel.id === G_id.ATTN) {
            return (
                <EntryGrid
                    id={props.panel.id}
                    elemid="attnGrid"
                    entrydataRef={entrydataRef}
                    dataRef={attndataRef}
                    columnRef={attncolRef}
                    columninfo={columninfo}
                    columns={columns}
                    type={tabletype(G_id.ATTN)}
                    fnc={fnc}
                    onFirstDataRendered={onFirstDataRendered}
                    statusKey={statusKey(G_id.ATTN)}
                    ValueChanged={() => storeRowData(G_id.ATTN)}
                    RowValueChanged={() => storeRowData(G_id.ATTN)}
                    RemoveRow={() => storeRowData(G_id.ATTN)}
                    panel={props.panel}
                />
            );
        }
        if (props.panel.id === G_id.ATTN2) {
            return (
                <EntryGrid
                    id={props.panel.id}
                    elemid="attnGrid2"
                    entrydataRef={entrydataRef}
                    dataRef={attndataRef2}
                    columnRef={attncolRef2}
                    columninfo={columninfo}
                    columns={columns}
                    type={tabletype(G_id.ATTN2)}
                    fnc={fnc}
                    onFirstDataRendered={onFirstDataRendered}
                    statusKey={statusKey(G_id.ATTN2)}
                    ValueChanged={() => storeRowData(G_id.ATTN2)}
                    RowValueChanged={() => storeRowData(G_id.ATTN2)}
                    RemoveRow={() => storeRowData(G_id.ATTN2)}
                    panel={props.panel}
                />
            );
        }
        if (props.panel.id === G_id.DEME) {
            return (
                <EntryGrid
                    id={props.panel.id}
                    elemid="demeGrid"
                    entrydataRef={entrydataRef}
                    dataRef={demedataRef}
                    columnRef={demecolRef}
                    columninfo={columninfo}
                    columns={columns}
                    type={tabletype(G_id.DEME)}
                    fnc={fnc}
                    onFirstDataRendered={onFirstDataRendered}
                    statusKey={statusKey(G_id.DEME)}
                    ValueChanged={() => storeRowData(G_id.DEME)}
                    RowValueChanged={() => storeRowData(G_id.DEME)}
                    RemoveRow={() => storeRowData(G_id.DEME)}
                    panel={props.panel}
                />
            );
        }
        if (props.panel.id === G_id.DEME2) {
            return (
                <EntryGrid
                    id={props.panel.id}
                    elemid="demeGrid2"
                    entrydataRef={entrydataRef}
                    dataRef={demedataRef2}
                    columnRef={demecolRef2}
                    columninfo={columninfo}
                    columns={columns}
                    type={tabletype(G_id.DEME2)}
                    fnc={fnc}
                    onFirstDataRendered={onFirstDataRendered}
                    statusKey={statusKey(G_id.DEME2)}
                    ValueChanged={() => storeRowData(G_id.DEME2)}
                    RowValueChanged={() => storeRowData(G_id.DEME2)}
                    RemoveRow={() => storeRowData(G_id.DEME2)}
                    panel={props.panel}
                />
            );
        }
        if (props.panel.id === G_id.FILE) {
            //v1.4
            return (
                <EntryFiles
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={fileRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.id === G_id.NB) {
            if (isEmpty(columninfo)) return null;
            let coldef = columninfo.find(e => e.type === props.panel.type);
            return (
                <EntryRemarks
                    id={"remarkspanel" + props.panel.type}
                    def={coldef}
                    dataRef={entrydataRef}
                    fnc={fnc}
                    ValueChanged={ValueChanged}
                />
            )
        }
        return null;

    }
    function EmptyPanel(id, type) {
        try {
            if (id === G_id.WASHEX) {
                return isEmpty(columns.find(e => e.logpid === "washex"));
            }
            if (!panel.some(e => e.id === id)) return true; //パネル定義なし
            if (!isEmpty(type)) {
                if (!panel.some(e => e.id === id && e.type === type)) return true; //パネル定義なし
            }
            if (id === G_id.BASE)  return isEmpty(textfields.find(e => e.type === type));
            if (id === G_id.NB) return isEmpty(columninfo.find(e => e.type === type));
            if (id === G_id.WASH) return false;
            if (id === G_id.WASH2) return false;
            let tbltype = tabletype(id);
            return !columns.some(e => e.type === tbltype);
        } catch { }
        return false;
    }
    function panelhidden(p) {
        if (isEmpty(p)) return false;
        if (p.id === G_id.IMAGE) {
            if (isEmpty(imageRef.current)) return true;
            if (imageRef.current.length === 0) return true;
            return p.hide;
        }
        if (p.id === G_id.FILE) {
            if (isEmpty(fileRef.current)) return true;
            if (fileRef.current.length === 0) return true;
            return p.hide;
        }
        if (EmptyPanel(p.id, p.type)) return true;
        return p.hide;
    }          

    function EntryForm() {
        return (
            <div style={{ padding: '5px 15px', paddingBottom:'300px', height: '100%', overflow: 'auto', backgroundColor: '#D8D8D8' }} ref={EntrybodyRef} onDragEnter={onDragEnter}>
                {panel.map((p,i) => {
                   return (
                        <Box
                           display={panelhidden(p) ? "none" : "flex"}
                           justifyContent="space-around"
                           alignItems="center"
                           padding="5px"
                            >
                            <Paper
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    padding: 10
                                }}
                           >
                               <div style={{ position: 'relative', marginBottom: 5 }}>
                                   {p.name} - <span style={{ fontStyle: 'oblique' }}>{p.name2}</span>
                                   {p.id !== '0' || layoutlock ? null :
                                       <div style={{ position: 'absolute', right: 40, top: -3 }} title="項目設定">
                                           <IconButton size="small" onClick={()=>SetBaseField(p.type)}  >
                                               <Icon style={{ fontSize: 16 }}>settings_applications</Icon>
                                           </IconButton>
                                       </div>
                                   }
                                   {layoutlock || sectionclose ? null :
                                       <div style={{ position: 'absolute', right: 10, top: -3 }}>
                                           <IconButton size="small" onClick={() => showpanel(p.id, p.type, false)}  >
                                               <Icon style={{ fontSize: 16 }}>close</Icon>
                                           </IconButton>
                                       </div>
                                   }
                               </div>
                                    <Contents panel={p}/>
                                </Paper >
                           </Box>
                    );
                })}
            </div>
        );
    }
    //function childRef(id) {
    //    switch (id) {
    //        case G_id.COMP:
    //            return childCompRef;
    //        case G_id.WASH:
    //            return childWashRef;
    //        case G_id.ATTN:
    //            return childAttnRef;
    //        case G_id.DEME:
    //            return childDemeRef;
    //        default:
    //            return null;
    //    }
    //}
    //const TagControl = forwardRef((props, ref) => { 
    //    const [no, setno] = useState('0');

    //    useImperativeHandle(ref, () => ({
    //        settagno(no) {
    //            setno(no);
    //        },
    //    }))

    //    return (
    //        <React.Fragment>
    //            <TextField
    //                select
    //                hiddenLabel
    //                defaultValue={'0'}
    //                value={no}
    //                onChange={(e) => setcarelabel(e.target.value)}
    //                variant="standard"
    //                size="small"
    //                style={{ width: 150 }}
    //                inputProps={{ style: { fontSize: 12 } }}
    //            >
    //                {taglist.map((option) => (
    //                    <MenuItem key={option.value} value={option.value} style={{ fontSize: 12 }}>
    //                        {option.label}
    //                    </MenuItem>
    //                ))}
    //            </TextField>
    //            {
    //                entrylock ? null :
    //                    <React.Fragment>
    //                        <IconButton size="small" onClick={() => caralabelAction(0)} title="ケアラベル追加">
    //                            <Icon style={{ fontSize: 16 }}>add_box</Icon>
    //                        </IconButton>
    //                        <IconButton size="small" onClick={() => caralabelAction(1)} title="ケアラベル削除">
    //                            <Icon style={{ fontSize: 16 }}>indeterminate_check_box</Icon>
    //                        </IconButton>
    //                        <IconButton size="small" onClick={() => caralabelAction(2)} title="名前の変更">
    //                            <Icon style={{ fontSize: 16 }}>drive_file_rename_outline</Icon>
    //                        </IconButton>
    //                    </React.Fragment>
    //            }
    //        </React.Fragment>
    //    );
    //});

    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                uploaded={fileuploaded}
                entrycallback={MenuAction}
                queryaction={MenuQueryAction}
                condition={true}
                entryform={true}
                tabs={true}
                show={Show}
                primaryid={'d_label'}
                primarykey={primarykeys}
                navmenu={entrylock ? navmenu.filter(e => e.menuid !== 'formupload'):navmenu}
                listcellchange={ListCellChange}
                masonry={false}
                lockcell={ListlockCell}
            >
            <EntryForm/>
            </MasterBase>
            <EntryLayout
                 columninfo={textfieldsall}
                 textfields={textfields} 
                 onAppry={SetLayout}
            />
            {formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM' ?
                <div>
                    <div style={{ position: 'absolute', top: 60, right: 15 }}>
                        <IconButton size="small" onClick={()=>fnc.current.entrysettingopen()} title={"レイアウト設定"} >
                            <Icon>table_chart</Icon>
                        </IconButton>
                    </div>
                    <Headline columninfo={columninfo} entrydata={entrydataRef.current} ></Headline>
                    <div style={{ position: 'absolute', top: 60, left: 210}}>
                    <Paper
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexWrap: 'wrap',
                            listStyle: 'none',
                            p: 0.2,
                            m: 0,
                        }}
                        component="ul"
                            elevation={0}
                            style={{ backgroundColor: "transparent", width: panelnavwidth() }}
                    >
                            {/*Panel Selector*/}
                            <SortablePanelSelector
                                axis={"x"}
                                items={panel}
                                onSortEnd={onPanelSortEnd}
                                distance={2}
                             />
                    </Paper>
                    </div>
                </div>
                : null}
            <AGFunc ref={AGRef} />
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
            <DataTree code={edittingcode} />
            <DropZone
                code={edittingcode}
                open={isDragActive}
                onclose={FileDropClose}
                actionurl={actionurl}
                uploaded={fileuploaded}
            />
        </div>
    );
};

